/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2025, Zumper
 * @description   ResidentQuotesModal Selectors
 */

import { selectEntity } from '@zcode-ui/web-zumper-global-state'
import { MODAL_TYPE, type State } from '@zcode/state-type'
import { selectOpen } from './index'

export const selectResidentQuotesModalOpen = (state: State) =>
  selectOpen(state, MODAL_TYPE.RESIDENT_QUOTES)

export const selectResidentQuotesModalIsPostLead = (state: State) =>
  state.modals.residentQuotesModal.isPostLead

export const selectResidentQuotesModalNextAction = (state: State) =>
  state.modals.residentQuotesModal.nextAction

export const selectResidentQuotesModalEntity = (state: State) =>
  selectEntity(state) ?? state.modals.residentQuotesModal.entity
